import { AfterViewInit, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { IOcbFileTransfer } from '@app/core';
import { DxSelectBoxComponent } from 'devextreme-angular';

@Component({
    selector: 'app-file-transfer-picker',
    templateUrl: './file-transfer-picker.component.html',
    styleUrls: ['./file-transfer-picker.component.scss'],
})
export class FileTransferPickerComponent implements AfterViewInit {

    @Input()
    public fileTransfers: IOcbFileTransfer[];

    @Input()
    public isDisabled: boolean = false;

    @Input()
    public isRequired: boolean = false;

    @Input()
    public selectedItem: IOcbFileTransfer;

    @Output()
    public selectedItemChange = new EventEmitter<IOcbFileTransfer>();

    @ViewChild(DxSelectBoxComponent)
    private selectBox: DxSelectBoxComponent;

    public ngAfterViewInit(): void {
        if (this.selectedItem) {
            this.selectBox.value = this.selectedItem.id;
        }
    }

    public selectFileTransfer(id: string) {
        this.selectBox.value = id;
    }

    public onSelectedItemChange($event: IOcbFileTransfer): void {
        if ($event == null) {
            return;
        }
        this.selectedItemChange.emit($event);
    }
}
